// TODO: À garder synchro avec @navbar-mobile-max dans variables.less
export const NAVBAR_MOBILE_MAX_BREAKPOINT = 817;
export const STICKY_HEADER_HEIGHT = 123;
export const SAVE_WISHLIST_URL = 'https://livewishlist.scriptengine.net/api/save-wishlist';
export const IMPULSE_LOADED_EVENT = 'page:loaded';
